import React from 'react'
import {FaGithub} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'

const SocialLinks = () => {

    const links = [
        {
            id: 1,
            child: (
                <>
                GitHub <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/RichardHorvatich',
            style: 'rounded-tr-md'
        },

        {
            id: 2,
            child: (
                <>
                Email <HiOutlineMail size={30} />
                </>
            ),
            href: 'mailto: richardhorvatich963@gmail.com',
            
        },

        {
            id: 3,
            child: (
                <>
                     Resume <BsFillPersonLinesFill size={30} />
                </>
            ),
            href: '#',
            style: 'rounded-br-md'
        },


    ]
  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
        <ul>
            
            {links.map(({id, child, href, style}) => (
                // eslint-disable-next-line
                <li key={id} className={`flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-15px] hover:rounded-md duration-300 bg-gray-500` + "" + style}>

                 
                <a href={href} className="flex justify-between items-center w-full 
                text-white">
                    
                        {child}
                    
                    </a>
                    </li>
            ))}

            
        </ul>
      
    </div>
  )
}

export default SocialLinks
